import { Grid, TextField, Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { addNewUser } from '../../../../api/UserManagement/addNewUser.api';
import { getFormItems } from '../../../../redux/forms/actions';
import { closeModal, openModal } from '../../../../redux/modals/action';
import CustomButton from '../../../layout/customButton/CustomButton';
import Modal from '../../../layout/modal/Modal';
import styles from './AddUserModal.module.scss';
import MenuItem from '@material-ui/core/MenuItem';
import { getCompanies } from '../../../../redux/userManagement/actions';
import AddProjectsModal from '../addProjectsModal/AddProjectsModal';
import ResetPasswordModal from '../resetPasswordModal/ResetPasswordModal';
import ProjectAccessibility from './projectsAccessibility/ProjectAccessibility';
import { getProjectById } from '../../../../api/UserManagement/getProjectById.api';
import { getRoleNameById } from '../../../../api/UserManagement/getRoleNameById.api';
import { setUserArchived } from '../../../../api/UserManagement/setUserArchive.api';
import { deleteUser } from '../../../../api/UserManagement/deleteUser.api';
import { editUser } from '../../../../api/UserManagement/editUser.api';
import { ReactComponent as ArchiveIcon } from '../../../../assets/icons/archive.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import {
	validatePhoneNumber,
	reformatPhoneString,
	removeAlphabeticalCharWithMaxLength,
} from '../../../../utils/validatePhoneNumber';
import { validateEmail } from '../../../../utils/validateEmail';
import { setAlert } from '../../../../redux/alerts/action';
import { clearUserById } from '../../../../redux/userManagement/actions';

const AddUserModal = ({
	showModal,
	closeModal,
	getFormItems,
	fields,
	defaultData,
	getCompanies,
	projects,
	openModal,
	modals,
	rolesOfAllProjects,
	userSelected,
	userById,
	handleEditAccessibility,
	projectSelectedCode,
	openDeleteUsersConfirmation,
	openArchiveUsersConfirmation,
	openUnarchiveUsersConfirmation,
	isArchived,
	setAlert,
	setNewRole,
	newRole,
	clearUserById,
	projectsList,
	setProjectsList,
}) => {
	const [formData, setFormData] = useState();
	const [errors, setErrors] = useState({});
	const [clearChipData, setClearChipData] = useState(false);

	useEffect(() => {
		getFormItems('userManagement', 'addNewUser');
		getCompanies();
	}, []);

	useEffect(() => {
		if (showModal) {
			setClearChipData(false);
		}
	}, [showModal]);

	useEffect(() => {
		setErrors({});
		if (userSelected !== undefined) {
			if (userById?.projectRoles) {
				setFormData({
					...userById,
					userType: userById.projectRoles[projectSelectedCode] ?? '',
					companyName: projectSelectedCode,
				});
				let projectsArr = [];
				for (let key in userById.projectRoles) {
					let label = '';
					let filteredProject = projects?.filter(
						(project) => project?.id === key
					);
					if (filteredProject && filteredProject.length > 0) {
						label = filteredProject[0].companyName;
					}
					projectsArr.push({
						key: key,
						role: userById.projectRoles[key],
						label: label,
					});
				}
				setProjectsList(projectsArr);
			}
		} else {
			setFormData(defaultData);
			setProjectsList();
		}
	}, [userSelected, userById, projectSelectedCode]);

	useEffect(() => {
		setFormData(defaultData);
	}, [defaultData]);

	useEffect(() => {
		if (newRole && Object.keys(newRole).length > 0) {
			let key = Object.keys(newRole)[0];
			setFormData({
				...formData,
				companyName: key,
				userType: newRole[key],
			});
		}
	}, [newRole]);

	const handleCloseModal = () => {
		closeModal('addUserMgmt');
		setProjectsList();
		setErrors({});
		setFormData(defaultData);
		setNewRole();
		clearUserById();
		setClearChipData(true);
	};

	const handleChange = (e, formData) => {
		console.log('e.target.name', formData);
		setErrors({
			...errors,
			[e.target.name]: false,
		});
		if (e.target.name === 'companyName') {
			let userType = '';
			if (
				userById?.projectRoles &&
				userById?.projectRoles[e.target.value]
			) {
				userType = userById?.projectRoles[e.target.value];
			}
			setFormData({
				...formData,
				companyName: e.target.value,
				userType: userType,
			});
		} else if (e.target.name === 'phoneNumber') {
			let phoneNum = removeAlphabeticalCharWithMaxLength(e.target.value);
			let value;
			if (validatePhoneNumber(phoneNum)) {
				value = reformatPhoneString(phoneNum);
			} else {
				value = phoneNum;
			}
			setFormData({
				...formData,
				phoneNumber: value,
			});
		} else {
			setFormData({ ...formData, [e.target.name]: e.target.value });
		}
	};

	const validateFormData = () => {
		let errorObj = {};

		if (!formData?.firstName) {
			errorObj.firstName = true;
		}
		if (!formData?.lastName) {
			errorObj.lastName = true;
		}
		if (!validatePhoneNumber(formData?.phoneNumber)) {
			errorObj.phoneNumber = true;
		}
		if (!validateEmail(formData?.email)) {
			errorObj.email = true;
		}
		if (!formData?.companyName) {
			errorObj.companyName = true;
		}
		if (!formData?.userType) {
			errorObj.userType = true;
		}

		setErrors(errorObj);

		if (Object.keys(errorObj).length > 0) {
			return false;
		} else {
			return true;
		}
	};

	const handleAdd = async () => {
		if (projectsList?.length > 0) {
			let validationResult = validateFormData();
			if (validationResult) {
				try {
					let updatedProjectsList = JSON.parse(
						JSON.stringify(projectsList)
					);
					if (formData?.companyName) {
						let foundIndex = updatedProjectsList.findIndex(
							(project) => {
								if (project?.key === formData.companyName) {
									return true;
								} else {
									return false;
								}
							}
						);
						if (foundIndex === -1) {
							updatedProjectsList.push({
								key: formData.companyName,
								role: formData.userType,
							});
						} else {
							updatedProjectsList[foundIndex].role =
								formData.userType;
						}
					}
					await addNewUser(
						formData?.firstName,
						formData?.lastName,
						formData?.email,
						formData?.phoneNumber,
						updatedProjectsList
					);
					setAlert('success', 'Create new user successfully.');
				} catch (error) {
					setAlert('error', error.message);
				}
				setFormData(defaultData);
				closeModal('addNewUser');
			}
		} else {
			let validationResult = validateFormData();
			if (validationResult) {
				try {
					await addNewUser(
						formData?.firstName,
						formData?.lastName,
						formData?.email,
						formData?.phoneNumber,
						[
							{
								key: formData?.companyName,
								role: formData?.userType,
							},
						]
					);
					setAlert('success', 'Create new user successfully.');
				} catch (error) {
					setAlert('error', error.message);
				}
				setFormData(defaultData);
				closeModal('addNewUser');
			}
		}
	};

	const handleEditUser = async (userId) => {
		if (projectsList?.length > 0) {
			let validationResult = validateFormData();
			if (validationResult) {
				let updatedProjectsList = JSON.parse(
					JSON.stringify(projectsList)
				);
				if (formData?.companyName) {
					let foundIndex = updatedProjectsList.findIndex(
						(project) => {
							if (project?.key === formData.companyName) {
								return true;
							} else {
								return false;
							}
						}
					);
					if (foundIndex === -1) {
						updatedProjectsList.push({
							key: formData.companyName,
							role: formData.userType,
						});
					} else {
						updatedProjectsList[foundIndex].role =
							formData.userType;
					}
				}
				try {
					await editUser(
						userId,
						formData?.firstName,
						formData?.lastName,
						formData?.email,
						formData?.phoneNumber,
						updatedProjectsList
					);
					setAlert('success', 'Edit user successfully.');
				} catch (error) {
					setAlert('error', error.message);
				}
				closeModal('addNewUser');
			}
		} else {
			let validationResult = validateFormData();
			if (validationResult) {
				try {
					await editUser(
						userId,
						formData?.firstName,
						formData?.lastName,
						formData?.email,
						formData?.phoneNumber,
						[
							{
								key: formData?.companyName,
								role: formData?.userType,
							},
						]
					);
					setAlert('success', 'Edit user successfully.');
				} catch (error) {
					setAlert('error', error.message);
				}
				closeModal('addNewUser');
			}
		}
	};

	const handleAddProject = () => {
		openModal('addProjects');
	};

	const handleArchiveUser = (userId) => {
		openArchiveUsersConfirmation([userId]);
		setFormData(defaultData);
		closeModal('addNewUser');
	};

	const handleDeleteUser = (userId) => {
		openDeleteUsersConfirmation([userId]);
		setFormData(defaultData);
		closeModal('addNewUser');
	};

	const handleUnarchiveUser = (userId) => {
		openUnarchiveUsersConfirmation([userId]);
		setFormData(defaultData);
		closeModal('addNewUser');
	};

	const handleResetPassword = () => {
		openModal('resetPassword');
	};

	return (
		<div className={styles.addUserModalWrapper}>
			<Modal
				show={showModal}
				close={() => handleCloseModal()}
				title={userSelected ? 'Edit User' : 'Add New User'}
			>
				<Grid container spacing={1} xs={12}>
					{fields &&
						formData &&
						fields?.map((field) => {
							return (
								<Grid item xs={6}>
									<TextField
										label={field.formLabel}
										variant='outlined'
										type={field?.formType}
										name={field?.formName}
										value={
											formData &&
											formData[field?.formName]
										}
										fullWidth
										autoComplete='off'
										onChange={(e) =>
											handleChange(e, formData)
										}
										select={
											field.formName === 'companyName' ||
											(field.formName === 'userType' &&
												true)
										}
										SelectProps={{
											style: {
												backgroundColor: 'none',

												'&.MuiSelect-select:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												MenuListProps: {
													disablePadding: true,
												},
											},
										}}
										MenuListProps={{
											disablePadding: true,
										}}
										defaultValue={
											formData &&
											formData[field?.formName]
										}
										helperText={
											field?.formName &&
											errors[field.formName] &&
											field?.errorMessage
										}
										error={
											field?.formName &&
											errors[field.formName]
										}
									>
										{field.formName === 'companyName' &&
											projects?.map((project) => (
												<MenuItem
													className={
														styles.idTypeItem
													}
													value={project?.id}
												>
													{project?.companyName}
												</MenuItem>
											))}
										{field.formName === 'userType' &&
											rolesOfAllProjects
												?.filter(
													(role) =>
														role.projectCode ===
														formData?.companyName
												)
												?.map((role) => (
													<MenuItem
														className={
															styles.idTypeItem
														}
														value={role?.roleId}
													>
														{role?.roleName}
													</MenuItem>
												))}
										{field.formName === 'userType' && (
											<MenuItem
												className={styles.idTypeItem}
												value=''
											>
												None
											</MenuItem>
										)}
									</TextField>
								</Grid>
							);
						})}
				</Grid>

				{userSelected && (
					<div className={styles.resetPassword}>
						<Button
							className={styles.resetPasswordBtn}
							onClick={handleResetPassword}
						>
							Reset User Password
						</Button>
					</div>
				)}

				<div className={styles.subHeader}>
					<div className={styles.subHeaderTitle}>
						Projects & Accessibility
					</div>
					{userSelected && !isArchived && (
						<Button
							startIcon={<ArchiveIcon />}
							className={styles.user_archive_btn}
							onClick={() => handleArchiveUser(userSelected)}
						>
							Archive User
						</Button>
					)}
					{userSelected && isArchived && (
						<Button
							startIcon={<ArchiveIcon />}
							className={styles.user_archive_btn}
							onClick={() => handleUnarchiveUser(userSelected)}
						>
							Unarchive User
						</Button>
					)}
				</div>

				<ProjectAccessibility
					projectsList={projectsList}
					setProjectsList={setProjectsList}
					handleAddProject={handleAddProject}
					handleEditAccessibility={handleEditAccessibility}
				/>

				<div
					className={styles.actions}
					style={{
						justifyContent: userSelected
							? 'space-between'
							: 'flex-end',
					}}
				>
					{userSelected && (
						<Button
							startIcon={<DeleteIcon />}
							className={styles.delete_user_btn}
							onClick={() => handleDeleteUser(userSelected)}
						>
							Delete User
						</Button>
					)}

					<div className={styles.actionsRight}>
						<Button
							className={styles.cancel_btn}
							onClick={handleCloseModal}
						>
							Cancel
						</Button>
						{userSelected ? (
							<CustomButton
								type={'submit'}
								width={166}
								height={42}
								onClick={() => handleEditUser(userSelected)}
							>
								Save
							</CustomButton>
						) : (
							<CustomButton
								type={'submit'}
								width={166}
								height={42}
								onClick={handleAdd}
							>
								Add
							</CustomButton>
						)}
					</div>
				</div>
			</Modal>
			<AddProjectsModal
				show={modals.addProjects}
				projectsList={projectsList}
				setProjectsList={setProjectsList}
				defaultRole={formData?.userType}
				userSelected={userSelected}
				clearChipData={clearChipData}
			/>
			<ResetPasswordModal show={modals.resetPassword} />
		</div>
	);
};

const mapStateToProps = (state) => ({
	fields: state.forms.form?.addNewUser?.fields,
	defaultData: state.forms.form.addNewUser?.formData,
	projects: state.userManagement.projects,
	modals: state.modals,
	rolesOfAllProjects: state.userManagement.rolesOfAllProjects,
	userById: state.userManagement.userById,
	projectSelectedCode: state.userManagement.projectSelectedCode,
});

export default connect(mapStateToProps, {
	closeModal,
	getFormItems,
	getCompanies,
	openModal,
	setAlert,
	clearUserById,
})(AddUserModal);
